import { useEffect, useRef, useState } from "react";

import "./BackendStatus.scss";

const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL || "http://localhost:3001/api";
const HEALTH_URL = API_BASE_URL.replace(/\/api$/, "/health");
const POLL_INTERVAL_MS = 30_000;

type Status = "connecting" | "online" | "offline";

export const BackendStatus = () => {
  const [status, setStatus] = useState<Status>("connecting");
  const [tooltip, setTooltip] = useState("Connecting to server...");
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const check = async () => {
    try {
      const res = await fetch(HEALTH_URL, { method: "GET" });
      if (res.ok) {
        setStatus("online");
        setTooltip("Server online");
      } else {
        setStatus("offline");
        setTooltip(`Server error (${res.status})`);
      }
    } catch {
      setStatus("offline");
      setTooltip("Server unreachable");
    }
  };

  useEffect(() => {
    check();
    timerRef.current = setInterval(check, POLL_INTERVAL_MS);
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, []);

  return (
    <div
      className={`BackendStatus BackendStatus--${status}`}
      title={tooltip}
      aria-label={tooltip}
    >
      <span className="BackendStatus__dot" />
    </div>
  );
};
